"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SectionShippingOffer = void 0;
var _analyticsData = require("@ori/analytics-data");
var _basketItem = require("@ori/basket-item");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _constants = require("../constants");
var _contexts = require("../contexts");
var _hooks = require("../hooks");
var _SectionItem = require("./SectionItem");
var _jsxRuntime = require("react/jsx-runtime");
const SectionShippingOffer = ()=>{
    const { getTestId } = (0, _testidGenerator.default)();
    const { formatMessage } = (0, _hooks.useTranslations)();
    const { shippingOffer } = (0, _contexts.useBasketContext)();
    const { isSimplifiedCheckout } = (0, _contexts.useCheckoutBasket)();
    const sectionTestId = getTestId('delivery');
    const baseMapperProps = (0, _react.useMemo)(()=>({
            isBundleItem: false,
            isSubscription: false,
            isOfferItem: true,
            testId: sectionTestId
        }), [
        sectionTestId
    ]);
    const actionsProps = (0, _react.useMemo)(()=>({
            isShippingOfferItem: true,
            placement: _analyticsData.Placement.Offers
        }), []);
    if (!shippingOffer || shippingOffer.items.length < 1) {
        return null;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_basketItem.BasketSection, {
        title: formatMessage('shippingOffer'),
        overrideMdMaxWidth: isSimplifiedCheckout ? undefined : "".concat(_constants.MAX_WIDTH, "px"),
        children: shippingOffer.items.map((item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_SectionItem.SectionItem, {
                item: item,
                mapperProps: baseMapperProps,
                actionsProps: {
                    ...actionsProps,
                    offerChoiceId: shippingOffer.choiceId
                }
            }, "delivery-offer-item-".concat(item.itemCode, "-").concat(item.itemType, "-").concat(item.lineNumber, "-").concat(item.totalPrice)))
    });
};
exports.SectionShippingOffer = SectionShippingOffer;
